import {find, findIn} from "@elements/dom-utils"
import Modal from 'bootstrap/js/dist/modal';

export function init () {
    let infoArea = find('#infoModal');
    if(infoArea){
        let modalInstance = infoArea.dataset.instance;
        let infoModal = new Modal(infoArea);
        if (!sessionStorage.getItem('info' + modalInstance)) {
            infoModal.show();
        }

        infoArea.addEventListener('hide.bs.modal', function () {
            sessionStorage.setItem('info' + modalInstance,'closed');
        });

    }
}